var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.temDemanda)?_c('credenciamento-execucao-vazio',{on:{"atualizar":_vm.buscarDemandas}}):_c('div',[_c('credenciamento-execucao-tabela')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }